module.exports = __webpack_public_path__ + "img/benefit-gold-member.1ae375eb.png";